import React, { FC } from 'react'
import { Button, Icon, Table, Tooltip } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { ArtistAvatar } from 'components'

import { IAssignedProjectsItem } from '../../types'
import { AssignedProjectsListProps } from './AssignedProjectsList.props'
import './AssignedProjectsList.scss'

const AssignedProjectsList: FC<AssignedProjectsListProps> = ({ assignedProjects, unassignProject, emptyText }) => {

  const columns: ColumnsType<IAssignedProjectsItem>[] = [
    {
      key: 'avatar',
      title: '',
      sortable: false,
      align: 'left',
      render: (_, project) => (
        <ArtistAvatar
          className="assigned-projects-list__avatar"
          facebookId={project.facebookId}
          spotifyId={project.spotifyId}
          size="s"
        />
      )
    },
    {
      dataIndex: 'artistName',
      key: 'artistName',
      title: 'Artist',
      sortable: false,
      align: 'left',
      render: (value) => <b>{value}</b>
    },
    {
      dataIndex: 'projectName',
      key: 'projectName',
      title: 'Project',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: 'projectId',
      key: 'projectId',
      title: 'ID No:',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: '',
      key: 'delete',
      title: '',
      sortable: false,
      align: 'right',
      width: 50,
      render: (_, __, idx: number) => (
        <Tooltip message="Delete Project?" colorType="danger">
          <Button
            onClick={() => unassignProject(idx)}
            icon={<Icon name="trash-can" prefix="fal" />}
            colorType="secondary-black"
            containerStyle="link"
            size="sm"
          />
        </Tooltip>
      )
    }
  ]

  return (
    <>
      <h3 className="assigned-projects-list__title">Assigned Projects</h3>
      <Table
        emptyText={emptyText}
        className="assigned-projects-list"
        rowKey={(record) => record.projectId}
        columns={columns}
        data={assignedProjects}
        pagination={false}
      />
    </>
  )
}

export default AssignedProjectsList
